export default class WapiReanalysisSettings {
  constructor() {
    this.parameters = [];
    this.is_interpolate_preset = false;
    this.is_interpolate_point = false;
    /**
     * С какой даты доступен реанализ, если не указано то с любой даты
     */
    this.available_from = null;
    /**
     * По какую дату доступен реанализ, если не указано, то по любую дату
     */
    this.available_to = null;
  }

  get values() {
    return this.parameters.filter(x => x.checked).map(x => x.value);
  }
}
